const STORAGE_KEY = "api-generator-wizard";

const normalizePath = (pathname) => {
  const base = process.env.PUBLIC_URL || "";
  let path = pathname || "/";
  if (base && path.startsWith(base)) {
    path = path.slice(base.length) || "/";
  }
  return path;
};

export const isApiGeneratorRoute = (pathname) => {
  const path = normalizePath(pathname);
  return path === "/api-generator" || path.startsWith("/api-generator/");
};

export const loadApiGeneratorPersistence = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveApiGeneratorPersistence = (data) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.warn("Failed to persist API generator state", error);
  }
};

export const clearApiGeneratorPersistence = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export const hasApiGeneratorPersistence = () => {
  const data = loadApiGeneratorPersistence();
  return Boolean(data?.selectedConfig && Number(data?.currentStep) > 1);
};

export const resolveWizardStep = (data) => {
  if (!data) return 1;
  const step = Number(data.currentStep) || 1;
  if (step >= 3 && data.selectedConfig && data.currentModel && data.selectedMethod) {
    return 3;
  }
  if (step >= 2 && data.selectedConfig) {
    return 2;
  }
  return 1;
};

export const getPersistedWizardUiState = () => {
  const data = loadApiGeneratorPersistence();
  if (!data) {
    return {
      currentStep: 1,
      query: { combinator: "and", rules: [] },
      fileName: "",
      saveApi: false,
      fieldNameFilter: "",
      labelNameFilter: "",
      selectAll: false
    };
  }

  return {
    currentStep: resolveWizardStep(data),
    query: data.query || { combinator: "and", rules: [] },
    fileName: data.fileName || "",
    saveApi: Boolean(data.saveApi),
    fieldNameFilter: data.fieldNameFilter || "",
    labelNameFilter: data.labelNameFilter || "",
    selectAll: Boolean(data.selectAll)
  };
};

export const getPersistedWizardContextState = () => {
  const data = loadApiGeneratorPersistence();
  if (!data) return null;

  return {
    currentModel: data.currentModel ?? null,
    selectedConfig: data.selectedConfig ?? null,
    selectedVersion: data.selectedVersion ?? null,
    selectedRecord: data.selectedRecord ?? null,
    selectedFields: Array.isArray(data.selectedFields) ? data.selectedFields : [],
    completeQuery: data.completeQuery ?? [],
    QBFields: Array.isArray(data.QBFields) ? data.QBFields : [],
    filterFields: Array.isArray(data.filterFields) ? data.filterFields : [],
    requiredFields: Array.isArray(data.requiredFields) ? data.requiredFields : [],
    fieldType: data.fieldType && typeof data.fieldType === "object" ? data.fieldType : {},
    selectedMethod: data.selectedMethod ?? "",
    models: Array.isArray(data.models) ? data.models : [],
    prevModel: data.prevModel ?? null,
    prevConfig: data.prevConfig ?? null,
    prevVersion: data.prevVersion ?? null
  };
};
